import React, { useEffect } from 'react';
import { ThemeContextProvider } from './utils/ThemeContext';
import { MainBody } from './styles/Global.styled';

import Navbar from './components/Navbar';
import Showcase from './components/Showcase';
import MySkills from './components/MySkills';
import MyExperience from './components/MyExperience';
import MyProjects from './components/MyProjects';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <ThemeContextProvider>
      <MainBody>
        <Navbar />
        <Showcase />
        <MySkills />
        <MyExperience />
        <MyProjects />
        <Footer />
      </MainBody>
    </ThemeContextProvider>
  );
}

export default App;
